<ng-template vdrDialogTitle>{{
  title | translate : translationVars
}}</ng-template>

<form class="form" [formGroup]="detailForm">
  <vdr-card [title]="'Product'">
    <div class="form-grid">
      <vdr-form-field [label]="'catalog.product-name' | translate" for="name">
        <input
          id="name"
          type="text"
          formControlName="name"
          [readonly]="!(updatePermissions | hasPermission)"
          (input)="updateSlug($event.target.value)"
        />
      </vdr-form-field>
      <vdr-form-field
        [label]="'catalog.slug' | translate"
        for="slug"
        [errors]="{ pattern: 'catalog.slug-pattern-error' | translate }"
      >
        <input
          id="slug"
          type="text"
          formControlName="slug"
          [readonly]="!(updatePermissions | hasPermission)"
        />
      </vdr-form-field>
    </div>

    <vdr-tabbed-custom-fields
      entityName="Product"
      [customFields]="noFreeGiftCustomFields"
      [customFieldsFormGroup]="detailForm.get('customFields')"
      [readonly]="!(updatePermissions | hasPermission)"
    ></vdr-tabbed-custom-fields>

    <vdr-form-field class="mt-2" [label]="'catalog.product-images' | translate">
    </vdr-form-field>
    <vdr-assets
      class="mt-2"
      [assets]="assetChanges.assets"
      [featuredAsset]="assetChanges.featuredAsset"
      [updatePermissions]="updatePermissions"
      (change)="assetChanges = $event"
    ></vdr-assets
  ></vdr-card>

  <vdr-card
    class="mt-2"
    [title]="'catalog.product-variants' | translate"
    style="display: none"
  >
    <div>
      <gift-generate-product-variants
        (variantsChange)="createVariantsConfig = $event"
      ></gift-generate-product-variants>
    </div>
    <!-- <ng-template #variantList>
          <vdr-product-variant-list
            [productId]="this.id"
            dataTableId="product-detail-variants-list"
            [hideLanguageSelect]="true"
          ></vdr-product-variant-list>
        </ng-template> -->
    <!-- <div class="mx-3" *ngIf="(isNew$ | async) === false">
          <a class="button" [routerLink]="['manage-variants']">
            <clr-icon shape="add-text"></clr-icon>
            {{ "catalog.manage-variants" | translate }}</a
          >
        </div> -->
  </vdr-card>
</form>

<ng-template vdrDialogButtons>
  <button
    class="button primary"
    (click)="create()"
    [disabled]="
      detailForm.invalid ||
      createVariantsConfig.variants.length === 0
    "
  >
    {{ "common.create" | translate }}
  </button>
</ng-template>
